document.addEventListener("DOMContentLoaded", function() {
  var readMoreBtns = document.querySelectorAll('.readMoreBtn');

  readMoreBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
          var content = this.previousElementSibling;

          if (content.classList.contains('read-more-expanded')) {
              content.style.maxHeight = content.scrollHeight + "px";
              setTimeout(() => {
                  content.style.maxHeight = "110px";
              }, 10);
              content.classList.remove('read-more-expanded');
              this.textContent = 'Read More';
          } else {
              content.style.maxHeight = "110px";
              setTimeout(() => {
                  content.style.maxHeight = content.scrollHeight + "px";
              }, 10); 
              content.classList.add('read-more-expanded');
              this.textContent = 'Read Less';
          }
      });
  });
});
